import { makeStyles } from '@mui/styles'

const styles = makeStyles(() => ({
  button: {
    margin: 5,
  },
}))

export default styles
